import { LogService } from 'library/ts/utilities/logger/LogService';
export class BackgroundImage {
    #logger;
    constructor(container, imageURL, containerCSS = {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }, onSuccess = undefined, onFailure = undefined, utils, runtimeVO) {
        this.#logger = LogService.create({ prefixes: ['SmartTag:', 'Skin:', this.name + ':'] });
        const backgroundImage = new Image();
        if (runtimeVO?.top?.ssl) {
            if (utils.URL.valid(imageURL))
                imageURL = utils.URL.toHTTPS(imageURL, true);
        }
        if (utils.Type.isObject(containerCSS)) {
            Object.keys(containerCSS).forEach((key) => {
                container.style[key] = containerCSS[key];
            });
        }
        backgroundImage.onload = (event) => {
            this.#logger.log('Image onload:', event);
            container.style.backgroundImage = 'url(' + backgroundImage.src + ')';
            if (utils.Type.isFunction(onSuccess))
                onSuccess(container);
        };
        backgroundImage.onerror = (event) => {
            this.#logger.warn('Image onerror:', event);
            if (utils.Type.isFunction(onFailure))
                onFailure(event);
        };
        this.#logger.log('Load Image:', imageURL);
        backgroundImage.src = imageURL;
    }
    get name() {
        return 'BackgroundImage';
    }
}
